import styled, { css, keyframes } from 'styled-components';

//TODO USE THEMES FOR COLORS

const pulse = keyframes`
        0% {
            box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
        }
        70% {
            box-shadow: 0 0 0 20px rgba(255, 255, 255, 0);
        }
        100% {
            box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
        }
`;

export type IconSize = 'small' | 'large';

interface ChildrenWrapperProps {
    $rotate?: boolean;
    $rounded?: boolean;
}
export const ChildrenWrapper = styled.div<ChildrenWrapperProps>`
    margin: 0 auto;
    transition: all 0.3s ease-in-out;
    overflow: hidden;
    border-radius: 50%;
    svg {
        path {
            transition: all 0.2s ease-in-out;
            fill: white;
        }
    }

    &:hover {
        svg {
            transform: scale(1.2);
            path {
                fill: ${({ theme }) => theme.shades.white[30]};
            }
        }
    }

    ${({ $rounded }) =>
        $rounded &&
        css`
            border-radius: 50%;
        `}
    ${({ $rotate }) =>
        $rotate &&
        css`
            transform: rotate(45deg);
        `}
`;

export const IconContainer = styled.div`
    position: absolute;
    z-index: -1;
    transition: all 0.3s ease-in-out;
    border: 1px solid white;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(27.9158px);
`;

interface WrapperProps {
    $size?: IconSize;
    $primary?: boolean;
    $secondary?: boolean;
    $active?: boolean;
    $disabled?: boolean;
}

export const IconButtonBackgroundBorder = styled.div<WrapperProps>`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    ${({ $disabled }) =>
        $disabled &&
        css`
            opacity: 0.5;
            pointer-events: none;
        `}

    ${({ $size }) =>
        $size == 'large'
            ? css`
                  width: 54px;
                  height: 54px;
                  ${IconContainer} {
                      width: 54px;
                      height: 54px;
                  }
              `
            : css`
                  width: 30px;
                  height: 30px;
                  ${IconContainer} {
                      width: 30px;
                      height: 30px;
                  }
              `}

    ${({ $primary }) =>
        $primary &&
        css`
            ${IconContainer} {
                animation: ${pulse} 2s infinite;
            }
            &:hover {
                ${IconContainer} {
                    animation: none;
                    transform: scale(0.7);
                }
            }
        `}

    ${({ $secondary }) =>
        $secondary &&
        css`
            &:hover {
                ${IconContainer} {
                    background: white;
                }
                ${ChildrenWrapper} {
                    path {
                        fill: black;
                    }
                }
            }
        `}

    ${({ $primary, $active }) =>
        $primary &&
        $active &&
        css`
            ${IconContainer} {
                animation: none;
                transform: scale(0.7);
            }
        `}
`;

interface StyledImageProps {
    $rotate?: boolean;
    $rounded?: boolean;
}

export const StyledIconButton = styled.img<StyledImageProps>`
    margin: 0 auto;
    width: 21px;

    transition: transform 0.3s ease-in-out;
    ${({ $rounded }) =>
        $rounded &&
        css`
            border-radius: 50%;
        `}
    ${({ $rotate }) =>
        $rotate &&
        css`
            transform: rotate(45deg);
        `}
`;

export const Caption = styled.span`
    position: absolute;
    bottom: -40%;
    left: 50%;
    transform: translateX(-50%);
    width: max-content;
    text-transform: uppercase;
`;
